__webpack_require__.p = "https://static.age.awaze.com/landing-pages-mfe/fe43627/_next/";